import './components/ga-events';            //should be on top of each page's JS file
import './components/wizcase-ad-cookies';
import './components/swipe-for-more';       // should be as soon as possible
import './parts/navigation';
import './parts/keyboard-navigation';
import './parts/accept-cookies';
import './parts/ftc-disclosure';
import './components/accessibility-widget';
import Tooltips from './components/tooltips';
import './widgets/quick-nav';
import './components/gallery';
import './components/youtube-facade';
import './components/js-links';
import './components/scroll-top-btn';
import './components/svg';

import '../vendor/splide.min';

import ExitPopup from './components/exit-popup';

import $ from 'cash-dom';
import PrequalState from './parts/ppc/prequalify-modal/PrequalState';
import CustomSelect from './components/custom-select';
import loadDisclosureBanner from './parts/disclosure-banner-loader';

PrequalState.getInstance().isPrequalShown = false;

if ($('#top_loans_carousel').length) {
  new Splide('#top_loans_carousel').mount();
}

if ($('#posts_carousel').length) {
  new Splide('#posts_carousel').mount();
}

$(function () {
  ExitPopup.init();
  Tooltips.getInstance().initOnce();
  CustomSelect.init();
  loadDisclosureBanner();
});
